import { Link } from "react-router-dom";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";

const artistPlans = [
  {
    id: "artist-starter",
    name: "Starter",
    nameKo: "스타터",
    price: 29900,
    color: "#ffd60a",
    gradient: "from-[#ffd60a]/12 to-transparent",
    border: "border-[#ffd60a]/35",
    badge: null as string | null,
    questLimit: "월 3개",
    ipLimit: "4종",
    features: [
      "아티스트 공식 프로필 페이지 생성",
      "월 3개 캠페인 출제",
      "IP 이미지 최대 4종 등록",
      "팬 제출 영상 열람",
      "기본 팬 참여 통계",
      "아티스트 인증 배지",
    ],
    cta: "스타터로 시작",
    ctaLink: "/signup?plan=artist-starter",
  },
  {
    id: "artist-pro",
    name: "Pro",
    nameKo: "프로",
    price: 79900,
    color: "#ff6eb4",
    gradient: "from-[#ff6eb4]/15 to-transparent",
    border: "border-[#ff6eb4]/45",
    badge: "추천" as string | null,
    questLimit: "월 10개",
    ipLimit: "12종",
    features: [
      "아티스트 공식 프로필 페이지 생성",
      "월 10개 캠페인 출제",
      "IP 이미지 최대 12종 등록",
      "팬 제출 영상 열람 + 다운로드",
      "상세 팬 참여 통계 & 분석",
      "커뮤니티 공지 무제한",
      "캠페인 보상 커스터마이징",
      "팬 랭킹 & 리더보드 관리",
      "우선 노출 (홈 피처드)",
    ],
    cta: "Pro로 시작",
    ctaLink: "/signup?plan=artist-pro",
  },
  {
    id: "artist-label",
    name: "Label",
    nameKo: "레이블",
    price: 199900,
    color: "#c77dff",
    gradient: "from-[#c77dff]/12 to-transparent",
    border: "border-[#c77dff]/35",
    badge: "엔터프라이즈" as string | null,
    questLimit: "무제한",
    ipLimit: "무제한",
    features: [
      "소속 아티스트 최대 10명 관리",
      "아티스트별 공식 프로필 페이지",
      "캠페인 무제한 출제",
      "IP 이미지 무제한 등록",
      "고급 분석 대시보드",
      "팬미팅 / 이벤트 연동",
      "전담 매니저 배정",
      "API 연동 지원",
    ],
    cta: "레이블 문의",
    ctaLink: "/signup?plan=artist-label",
  },
];

const steps = [
  { step: 1, icon: "ri-vip-crown-line", color: "#ffd60a", title: "플랜 구독", desc: "아티스트 플랜을 선택하고 구독을 시작하세요. 즉시 대시보드에 접근할 수 있습니다." },
  { step: 2, icon: "ri-user-star-line", color: "#ff6eb4", title: "프로필 페이지 생성", desc: "아티스트 이름, 그룹명, 소개, IP 이미지를 입력하면 공식 프로필 페이지가 즉시 생성됩니다." },
  { step: 3, icon: "ri-film-line", color: "#4fc3f7", title: "캠페인 출제", desc: "뮤직비디오 신, 안무, 챌린지 등 원하는 캠페인을 직접 출제하고 팬들의 참여를 유도하세요." },
  { step: 4, icon: "ri-bar-chart-line", color: "#c77dff", title: "팬 활동 관리", desc: "팬들이 제출한 영상을 확인하고 통계를 분석하며 에디터 픽을 선정하세요." },
];

export default function ArtistRegisterPage() {
  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white">
      <Navbar />

      {/* Hero */}
      <div className="relative pt-24 pb-16 px-6 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/4123162160e9fb1bad614a99bb332bca.jpg"
            alt="Artist Register Hero"
            className="w-full h-full object-cover object-top opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0f]/50 via-[#0a0a0f]/40 to-[#0a0a0f]" />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-6 h-6 flex items-center justify-center rounded-full bg-gradient-to-r from-[#ffd60a] to-[#ff6eb4]">
              <i className="ri-user-star-fill text-white text-xs" />
            </span>
            <span className="text-[#ffd60a] text-xs font-semibold tracking-widest uppercase">For Artists</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-black text-white mb-4 leading-tight">
            팬들과 함께 만드는<br />
            <span className="bg-gradient-to-r from-[#ffd60a] to-[#ff6eb4] bg-clip-text text-transparent">아티스트 공식 페이지</span>
          </h1>
          <p className="text-white/60 text-base max-w-xl mx-auto mb-8 leading-relaxed">
            아티스트 플랜을 구독하면 즉시 공식 프로필 페이지가 생성됩니다.<br />
            캠페인을 출제하고 팬들이 만든 뮤직비디오 신과 안무를 함께 즐기세요.
          </p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <Link to="/pricing"
              className="px-8 py-3.5 rounded-full font-bold text-sm cursor-pointer whitespace-nowrap hover:opacity-90 transition-opacity flex items-center gap-2"
              style={{ background: "linear-gradient(135deg, #ffd60a, #ff6eb4)", color: "#0a0a0f" }}>
              <i className="ri-vip-crown-line" />
              아티스트 플랜 보기
            </Link>
            <Link to="/artists"
              className="px-8 py-3.5 rounded-full border border-white/30 text-white text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-white/10 transition-colors flex items-center gap-2">
              <i className="ri-user-star-line" />
              아티스트 목록 보기
            </Link>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 pb-20">

        {/* How It Works */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">
              시작하는 방법
            </h2>
            <p className="text-white/40 text-sm">플랜 구독 후 즉시 아티스트 페이지를 운영할 수 있습니다</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {steps.map((s, i) => (
              <div key={s.step} className="relative text-center">
                {i < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-8 left-[65%] w-[70%] h-px bg-white/10 z-0" />
                )}
                <div className="relative z-10">
                  <div className="w-16 h-16 flex items-center justify-center rounded-2xl mx-auto mb-4"
                    style={{ background: `${s.color}15`, border: `1px solid ${s.color}30` }}>
                    <i className={`${s.icon} text-2xl`} style={{ color: s.color }} />
                  </div>
                  <div className="w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold mx-auto mb-3"
                    style={{ background: s.color, color: "#0a0a0f" }}>
                    {s.step}
                  </div>
                  <h3 className="text-white font-bold text-sm mb-2">{s.title}</h3>
                  <p className="text-white/40 text-xs leading-relaxed">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Artist Plans */}
        <div className="mb-20">
          <div className="text-center mb-10">
            <div className="flex items-center justify-center gap-2 mb-3">
              <span className="w-6 h-6 flex items-center justify-center rounded-full bg-gradient-to-r from-[#ffd60a] to-[#ff6eb4]">
                <i className="ri-vip-crown-fill text-white text-xs" />
              </span>
              <span className="text-[#ffd60a] text-xs font-semibold tracking-widest uppercase">Artist Plans</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">
              아티스트 요금제
            </h2>
            <p className="text-white/40 text-sm">구독 즉시 아티스트 페이지 생성 + 캠페인 출제 기능 활성화</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {artistPlans.map((plan) => (
              <div key={plan.id}
                className={`relative rounded-2xl border bg-gradient-to-b ${plan.gradient} bg-[#0f0f1a] p-7 flex flex-col ${plan.border} ${plan.badge === "추천" ? "scale-[1.03]" : ""}`}>
                {plan.badge && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full text-xs font-bold"
                    style={{ background: `linear-gradient(135deg, ${plan.color}, ${plan.color}99)`, color: plan.id === "artist-starter" ? "#0a0a0f" : "white" }}>
                    {plan.badge}
                  </div>
                )}

                <div className="mb-5">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-white font-black text-xl">{plan.name}</span>
                    <span className="text-white/40 text-sm">({plan.nameKo})</span>
                  </div>
                  <div className="flex items-end gap-1">
                    <span className="text-3xl font-black text-white">₩{plan.price.toLocaleString()}</span>
                    <span className="text-white/40 text-sm mb-1">/ 월</span>
                  </div>
                </div>

                {/* Key Metrics */}
                <div className="grid grid-cols-2 gap-2 mb-5">
                  <div className="rounded-xl p-3 text-center" style={{ background: `${plan.color}10`, border: `1px solid ${plan.color}25` }}>
                    <div className="font-black text-base" style={{ color: plan.color }}>{plan.questLimit}</div>
                    <div className="text-white/40 text-[10px] mt-0.5">캠페인 출제</div>
                  </div>
                  <div className="rounded-xl p-3 text-center" style={{ background: `${plan.color}10`, border: `1px solid ${plan.color}25` }}>
                    <div className="font-black text-base" style={{ color: plan.color }}>{plan.ipLimit}</div>
                    <div className="text-white/40 text-[10px] mt-0.5">IP 이미지</div>
                  </div>
                </div>

                <ul className="flex flex-col gap-2.5 mb-6 flex-1">
                  {plan.features.map((f) => (
                    <li key={f} className="flex items-start gap-2.5 text-sm text-white/70">
                      <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-xs" style={{ color: plan.color }} />
                      </div>
                      {f}
                    </li>
                  ))}
                </ul>

                <Link to={plan.ctaLink}
                  className="w-full py-3.5 rounded-xl font-bold text-sm text-center transition-all cursor-pointer whitespace-nowrap block hover:opacity-90"
                  style={{
                    background: `linear-gradient(135deg, ${plan.color}, ${plan.color}bb)`,
                    color: plan.id === "artist-starter" ? "#0a0a0f" : "white",
                  }}>
                  {plan.cta}
                </Link>
              </div>
            ))}
          </div>

          <div className="mt-6 text-center">
            <Link to="/pricing"
              className="inline-flex items-center gap-2 text-white/40 text-sm hover:text-white/70 transition-colors cursor-pointer">
              <i className="ri-information-line" />
              전체 요금제 상세 비교 보기
            </Link>
          </div>
        </div>

        {/* Feature Showcase */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-20">
          {/* Artist Page Preview */}
          <div className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#ffd60a]/15 border border-[#ffd60a]/30">
                <i className="ri-user-star-line text-xl text-[#ffd60a]" />
              </div>
              <div>
                <h3 className="text-white font-bold text-base">아티스트 프로필 페이지</h3>
                <p className="text-white/40 text-xs">구독 즉시 자동 생성</p>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden border border-white/10 mb-4">
              <img
                src="https://readdy.ai/api/search-image?query=kpop%20female%20idol%20professional%20profile%20photo%2C%20elegant%20stage%20costume%2C%20pink%20lighting%2C%20clean%20studio%20background%2C%20high%20fashion%20portrait&width=600&height=280&seq=artist-profile-preview-001&orientation=landscape"
                alt="Artist Profile Preview"
                className="w-full h-40 object-cover object-top"
              />
            </div>
            <ul className="flex flex-col gap-2">
              {["아티스트 이름 & 그룹명", "공식 소개 & 장르 태그", "IP 이미지 갤러리", "팔로워 & 퀘스트 통계", "소셜 미디어 링크"].map((item) => (
                <li key={item} className="flex items-center gap-2 text-white/60 text-sm">
                  <i className="ri-check-line text-[#ffd60a] text-xs" />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Quest Creation Preview */}
          <div className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#ff6eb4]/15 border border-[#ff6eb4]/30">
                <i className="ri-film-line text-xl text-[#ff6eb4]" />
              </div>
              <div>
                <h3 className="text-white font-bold text-base">캠페인 출제 기능</h3>
                <p className="text-white/40 text-xs">팬 참여 유도 & 관리</p>
              </div>
            </div>
            <div className="flex flex-col gap-3 mb-4">
              {[
                { type: "뮤직비디오 신", icon: "ri-film-line", color: "#ff6eb4", desc: "MV 오프닝, 클로즈업, 판타지 신 등" },
                { type: "안무 영상", icon: "ri-music-2-line", color: "#4fc3f7", desc: "포인트 안무, 칼군무, 솔로 댄스 등" },
                { type: "챌린지", icon: "ri-trophy-line", color: "#c77dff", desc: "특정 미션 수행 영상" },
              ].map((qt) => (
                <div key={qt.type} className="flex items-center gap-3 p-3 rounded-xl border border-white/8 bg-white/3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0" style={{ background: `${qt.color}18` }}>
                    <i className={`${qt.icon} text-sm`} style={{ color: qt.color }} />
                  </div>
                  <div>
                    <p className="text-white font-semibold text-sm">{qt.type}</p>
                    <p className="text-white/40 text-xs">{qt.desc}</p>
                  </div>
                </div>
              ))}
            </div>
            <ul className="flex flex-col gap-2">
              {["XP 보상 직접 설정", "마감일 & 참여 인원 관리", "팬 제출 영상 열람", "에디터 픽 직접 선정"].map((item) => (
                <li key={item} className="flex items-center gap-2 text-white/60 text-sm">
                  <i className="ri-check-line text-[#ff6eb4] text-xs" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center rounded-2xl border border-[#ffd60a]/20 bg-[#ffd60a]/5 p-10">
          <h3 className="text-white font-black text-2xl mb-3">지금 바로 아티스트 페이지를 만들어보세요</h3>
          <p className="text-white/50 text-sm mb-6">플랜 구독 후 즉시 공식 프로필 페이지 생성 + 캠페인 출제 기능 활성화</p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <Link to="/signup?plan=artist-starter"
              className="px-8 py-3.5 rounded-full font-bold text-sm cursor-pointer whitespace-nowrap hover:opacity-90 transition-opacity flex items-center gap-2"
              style={{ background: "linear-gradient(135deg, #ffd60a, #ff6eb4)", color: "#0a0a0f" }}>
              <i className="ri-user-star-line" />
              스타터로 시작 — ₩29,900/월
            </Link>
            <Link to="/pricing"
              className="px-8 py-3.5 rounded-full border border-white/20 text-white/70 text-sm font-medium whitespace-nowrap cursor-pointer hover:border-white/40 hover:text-white transition-all flex items-center gap-2">
              <i className="ri-list-check" />
              플랜 비교하기
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
